<template>
  <b-container fluid class="no-sided-margin">
    <b-row class="margin-top-md margin-bottom-md">
      <b-col cols="2">
        <b-card header-bg-variant="light" class="mb-4">
          <template #header>
            <div class="custom-card-header">
              <strong>
                <b-icon-funnel></b-icon-funnel>
                Filtri</strong>
            </div>
          </template>
          <b-card-body style="padding: 0.5rem">
            <b-form inline>
              <b-form-group>
                <b-form-checkbox v-model="filters.cardHolders" switch @change="findFiltered()">
                  <label class="mr-2"><strong>Titolari Carta Fidelity</strong></label>
                </b-form-checkbox>
              </b-form-group>
              <b-form-group>
                <b-form-checkbox v-model="filters.inactive" switch @change="findFiltered()">
                  <label class="mr-2"><strong>Anagrafiche Inattive</strong></label>
                </b-form-checkbox>
              </b-form-group>
            </b-form>
          </b-card-body>
        </b-card>
        <b-card header-bg-variant="light">
          <b-card-body style="padding: 0.5rem">
            <b-form id="form" @submit="findFiltered">
              <b-form-group label="Codice Cliente">
                <b-form-input v-model="filters.customerKey"/>
              </b-form-group>
              <b-form-group label="Codice Tessera">
                <b-form-input v-model="filters.barcode"/>
              </b-form-group>
              <b-form-group label="Nome Fidelity">
                <b-form-input v-model="filters.cardName"/>
              </b-form-group>
              <b-form-group label="Nome Sensei">
                <b-form-input v-model="filters.name"/>
              </b-form-group>
              <b-form-group label="Email">
                <b-form-input v-model="filters.email"/>
              </b-form-group>
              <b-form-group label="Numero di Telefono">
                <b-form-input v-model="filters.phoneNumber"/>
              </b-form-group>
              <b-form-group label="Data di inizio">
                <DatePicker ref="registrationStart" v-model="filters.registrationStart" id="registration-start"
                            :required="false"/>
              </b-form-group>
              <b-form-group label="Data di fine">
                <DatePicker ref="registrationEnd" v-model="filters.registrationEnd" id="registration-end"
                            :required="false"/>
              </b-form-group>
              <b-button type="submit" variant="primary" block id="search">
                <span v-show=false class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <b-icon-search/>&nbsp;Cerca
              </b-button>
              <b-button @click="exportCsv" variant="success" block>
                <b-icon-arrow-bar-down/>&nbsp;Download csv
              </b-button>
            </b-form>
          </b-card-body>
        </b-card>

      </b-col>
      <b-col cols="10">
        <b-card header-bg-variant="light">
          <template #header>
            <div style="height: 1.5rem">
              <span><strong><b-icon-book/>&nbsp;Utenti trovati</strong></span>
            </div>
            <div v-if="searched" class="float-right">
              <h6 v-show="!isEmpty(effectiveFilters)" class="filters-list-head">
                Filtri applicati:
                <b-badge class="filter-badge" v-show="effectiveFilters.customerKey" @click="removeFilter('customerKey')"
                         variant="info" pill tag="button">Codice Cliente:
                  <i>{{ effectiveFilters.customerKey }}</i>&nbsp;<b-icon-x-circle-fill
                    variant="light"/>
                </b-badge>
                <b-badge class="filter-badge" v-show="effectiveFilters.registrationStart"
                         @click="removeFilter('registrationStart')" variant="info" pill tag="button">Data Inizio:
                  <i>{{ effectiveFilters.registrationStart }}</i>&nbsp;<b-icon-x-circle-fill
                    variant="light"/>
                </b-badge>
                <b-badge class="filter-badge" v-show="effectiveFilters.registrationEnd"
                         @click="removeFilter('registrationEnd')" variant="info" pill tag="button">Data Fine:
                  <i>{{ effectiveFilters.registrationEnd }}</i>&nbsp;<b-icon-x-circle-fill
                    variant="light"/>
                </b-badge>
                <b-badge class="filter-badge" v-show="effectiveFilters.barcode"
                         @click="removeFilter('barcode')" variant="info" pill tag="button">Codice Tessera:
                  <i>{{ effectiveFilters.barcode }}</i>&nbsp;<b-icon-x-circle-fill
                    variant="light"/>
                </b-badge>
                <b-badge class="filter-badge" v-show="effectiveFilters.cardName"
                         @click="removeFilter('cardName')" variant="info" pill tag="button">Nome Fidelity:
                  <i>{{ effectiveFilters.cardName }}</i>&nbsp;<b-icon-x-circle-fill
                    variant="light"/>
                </b-badge>
                <b-badge class="filter-badge" v-show="effectiveFilters.name"
                         @click="removeFilter('name')" variant="info" pill tag="button">Nome Sensei:
                  <i>{{ effectiveFilters.name }}</i>&nbsp;<b-icon-x-circle-fill
                    variant="light"/>
                </b-badge>
                <b-badge class="filter-badge" v-show="effectiveFilters.email"
                         @click="removeFilter('email')" variant="info" pill tag="button">Email:
                  <i>{{ effectiveFilters.email }}</i>&nbsp;<b-icon-x-circle-fill
                    variant="light"/>
                </b-badge>
                <b-badge class="filter-badge" v-show="effectiveFilters.phoneNumber"
                         @click="removeFilter('phoneNumber')" variant="info" pill tag="button">Numero di Telefono:
                  <i>{{ effectiveFilters.phoneNumber }}</i>&nbsp;<b-icon-x-circle-fill
                    variant="light"/>
                </b-badge>
                <b-badge class="filter-badge" v-show="effectiveFilters.cardHolders"
                         @click="removeFilter('cardHolders')" variant="info" pill tag="button">Possessori Carta
                  Fidelity
                  <b-icon-x-circle-fill variant="light"/>
                </b-badge>
                <b-badge class="filter-badge" v-show="effectiveFilters.inactive"
                         @click="removeFilter('inactive')" variant="info" pill tag="button">Anagrafiche Inattive
                  <b-icon-x-circle-fill variant="light"/>
                </b-badge>
              </h6>
            </div>
          </template>
          <b-card-body>
            <b-table sticky-header="82vh" :no-border-collapse="true" responsive :fields="fields"
                     :items="customers" sort-by="ordinal_number">
              <template #cell(actions)="data" style="text-align: right">
                <b-button @click="showDetails(data.item)" pill title="Mostra dettaglio" size="sm" variant="info"
                          ref="history" v-b-tooltip.hover>
                  <b-icon-book-half size="sm"/>&nbsp;Dettaglio
                </b-button>
              </template>
              <template #cell(timestamp)="data">
                {{ asISODate(data.item.timestamp) }}
              </template>
              <template #cell(cardName)="data">
                {{ formatCardName(data.item.cardName) }}
              </template>
            </b-table>
          </b-card-body>
        </b-card>
        <b-pagination
          align="left"
          v-model="currentPage"
          @change="findCustomers"
          :per-page="pageSize"
          :total-rows="totalRows"
        ></b-pagination>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Sensei from "@/api/AutoshopApi"
import moment from "moment/moment";
import eventBus from "@/EventBus";
import DatePicker from "@/components/DatePicker.vue";


export default {
  name: 'Customers',
  components: {DatePicker},
  provide() {
    return {parentValidator: this.$validator}
  },
  mounted() {
    this.findCustomers(this.currentPage)
  },

  data: () => ({
    fields: [
      {key: "customerKey", label: "Codice Cliente"},
      {key: "displayName", label: "Nome e Cognome"},
      {key: "barcode", label: 'Tessera fidelity'},
      {key: "cardName", label: "Nome e Cognome fidelity"},
      {key: "status", label: 'Stato'},
      {key: "timestamp", label: 'Data'},
      {key: 'actions', label: '', class: 'text-right'}
    ],
    searched: false,
    customers: [],
    filters: {
      customerKey: null,
      registrationStart: null,
      registrationEnd: null,
      email: null,
      phoneNumber: null,
      cardName: null,
      cardHolders: null,
      barcode: null,
      inactive: null,
      name: null
    },
    currentPage: 1,
    pageSize: 20,
    totalRows: null,
    effectiveFilters: {}
  }),
  methods: {
    findFiltered(event) {
      if (event) {
        event.preventDefault()
      }
      this.currentPage = 1
      this.searched = true
      this.setFilters()

      this.findCustomers(this.currentPage)
    },
    findCustomers(currentPage) {
      this.currentPage = currentPage
      Sensei.findAllCustomers({...this.effectiveFilters, page: this.currentPage, pageSize: this.pageSize})
        .then(result => {
          this.fillCustomers(result)
          this.searched = !this.isEmpty(this.effectiveFilters)
        })
    },
    fillCustomers(customers) {
      this.customers = customers.customers
      this.totalRows = customers.rows
      this.pageSize = customers.pageSize
    },
    showDetails(customer) {
      eventBus.$emit('show-userDetails', customer, )
    },
    exportCsv() {
      this.setFilters()

      Sensei.downloadCsvCustomer(this.effectiveFilters)
    },
    setFilters() {
      if (this.filters.customerKey) this.effectiveFilters.customerKey = this.filters.customerKey.trim()
      if (this.filters.registrationStart) this.effectiveFilters.registrationStart = this.filters.registrationStart.trim()
      if (this.filters.registrationEnd) this.effectiveFilters.registrationEnd = this.filters.registrationEnd.trim()
      if (this.filters.email) this.effectiveFilters.email = this.filters.email.trim()
      if (this.filters.phoneNumber) this.effectiveFilters.phoneNumber = this.filters.phoneNumber.trim()
      if (this.filters.cardName) this.effectiveFilters.cardName = this.filters.cardName.trim()
      if (this.filters.barcode) this.effectiveFilters.barcode = this.filters.barcode.trim()
      if (this.filters.name) this.effectiveFilters.name = this.filters.name.trim()
      this.effectiveFilters.cardHolders = this.filters.cardHolders ? this.filters.cardHolders : null
      this.effectiveFilters.inactive = this.filters.inactive ? this.filters.inactive : null
    },
    asISODate: date => moment(date).format('DD/MM/YYYY HH:mm'),
    formatCardName: value => {
      if (value === "null null") return ""
      return value
    },
    isEmpty(object) {
      return Object.keys(object).length === 0 || Object.keys(object).every(key => object[key] == null)
    },
    removeFilter(field) {
      delete this.effectiveFilters[field]
      delete this.filters[field]

      if (field === 'registrationStart') {
        this.$refs.registrationStart.reset()
      }
      if (field === 'registrationEnd') {
        this.$refs.registrationEnd.reset()
      }
      this.findCustomers(this.currentPage)
    },
  }
}
</script>

<style>
</style>
